/** Lê query string — no NW.js (file://) `location.search` às vezes vem vazio. */
export function paramsUrlApp(): URLSearchParams {
  if (typeof window === 'undefined') return new URLSearchParams();

  const search = window.location.search || '';
  if (search.length > 1) return new URLSearchParams(search);

  const href = window.location.href || '';
  const q = href.indexOf('?');
  if (q >= 0) {
    const hashPos = href.indexOf('#', q);
    const qs = hashPos >= 0 ? href.slice(q + 1, hashPos) : href.slice(q + 1);
    return new URLSearchParams(qs);
  }

  return new URLSearchParams();
}

export function paramUrlApp(nome: string): string | null {
  const v = paramsUrlApp().get(nome);
  return v && v.length > 0 ? v : null;
}

declare global {
  interface Window {
    __ADE_MODULO__?: string;
    __ADE_AUTH_FILHA__?: string;
  }
}

export function moduloBootstrap(): string | null {
  if (typeof window === 'undefined') return null;
  if (window.__ADE_MODULO__) return window.__ADE_MODULO__;
  return paramUrlApp('modulo');
}

export function authFilhaBootstrap(): string | null {
  if (typeof window === 'undefined') return null;
  if (window.__ADE_AUTH_FILHA__) return window.__ADE_AUTH_FILHA__;
  if (paramUrlApp('ade_auth') !== '1') return null;
  return paramUrlApp('ade_sessao');
}
